import {
  combineReducers
} from 'redux';

import modalReducer from './modalReducer';
import secondModalReducer from './secondModalReducer';
import snackBarReducer from './snackBarReducer';
import loginReducer from './loginReducer';
import BranchServiceReducer from '../BranchServiceDashboard/reducers/branchServiceReducer';
import AdminReducer from '../Admin/reducers/adminReducer'

// import notificationReducer from './notificationReducer';


const rootReducer = combineReducers({
  modalReducer,
  secondModalReducer,
  snackBarReducer,
  loginReducer,
  BranchServiceReducer,
  AdminReducer
});

export default rootReducer;